"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart2, DollarSign, Sparkles, TrendingUp } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SmartNestOperations() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const techFeatures = [{
    icon: TrendingUp,
    title: "Revenue Management",
    description: "We use AI-powered data-driven tools to build custom pricing strategies for each of our properties. We stay on top of adjusting rates in real-time based on market demand, seasonality, and local events to maximize your revenue."
  }, {
    icon: BarChart2,
    title: "Digital Marketing",
    description: "Each property gets a custom-tailored digital strategy with search engine optimization, email marketing, and high-converting listing optimization on every platform we list on."
  }, {
    icon: Sparkles,
    title: "5 Star Hospitality",
    description: "We elevate the standard of short and mid-term rentals by providing a premium, seamless guest experience that keeps your property ranking at the top.\xA0"
  }];
  return <section id="smart-nest-operations" ref={sectionRef} className="dark bg-background text-foreground py-24 px-4" style={{
    backgroundColor: "hsl(30 10% 88%)"
  }}>
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-16">
          
          
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {techFeatures.map((feature, i) => {
          const Icon = feature.icon;
          return <Card key={i} data-index={i} className="group bg-card p-8 transition-all duration-500 hover:shadow-2xl hover:-translate-y-3 border-0" style={{
            opacity: sectionVisible ? 1 : 0,
            transform: sectionVisible ? "translateY(0)" : "translateY(30px)",
            transitionDelay: `${300 + i * 150}ms`,
            boxShadow: "0px 10px 40px 0px hsl(30 20% 10% / 0.04)"
          }}>
                <CardHeader className="px-0 pt-6">
                  <div className="mb-6 flex justify-center items-center">
                    <Icon className="w-16 h-16 transition-all duration-500 group-hover:scale-110" strokeWidth={1} style={{
                  color: i === 0 || i === 1 ? "white" : "var(--primary)"
                }} />
                  </div>
                  <CardTitle className="text-2xl font-sans font-semibold text-center">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-0 pb-0">
                  <p className="text-muted-foreground leading-relaxed text-center">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}